<div
  class="star-rating"
  [class.m-auto]="center"
  [style.width.px]="totalWidth"
  [style.height.px]="totalHeight"
>
  <div class="back-stars">
    <i
      class="fa fa-star-o"
      [ngClass]="{ mini: showMiniStar, med: showMediumStar, mega: showMegaStar }"
      *ngFor="let count of fullStarCount"
    ></i>
  </div>
  <div class="front-stars" [style.width.%]="width">
    <i
      class="fa fa-star"
      [ngClass]="{ mini: showMiniStar, med: showMediumStar, mega: showMegaStar }"
      *ngFor="let count of fullStarCount"
    ></i>
  </div>
</div>
